import React from "react";

import { cn } from "~/lib/cn";

type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  error?: unknown;
  onValueChange?: (value: string) => void;
};

/** The standard multi-line input, with an error state and a character counter. */
export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    { onValueChange, onChange, className, maxLength, error, value, ...props },
    ref,
  ) => {
    const currentLength = (value as string)?.length || 0;

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const newValue = e.currentTarget.value;
      if (onValueChange) {
        onValueChange(newValue);
      }
      if (onChange) {
        onChange(e);
      }
    };

    return (
      <div className="w-full">
        <textarea
          ref={ref}
          className={cn(
            "input flex min-h-[120px] w-full",
            error
              ? "border-red-600 focus:border-red-600 focus:ring-red-200"
              : null,
            className,
          )}
          value={value}
          onChange={handleChange}
          maxLength={maxLength}
          {...props}
        />
        {maxLength && (
          <div className="mt-1 text-right text-sm text-gray-500 tabular-nums">
            {currentLength}/{maxLength}
          </div>
        )}
      </div>
    );
  },
);

Textarea.displayName = "Textarea";
